import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function FormataStringData(data: string) {
  return data.split("-")[2] + "/" + data.split("-")[1] + "/" + data.split("-")[0];
}

export function FormataStringDataSemAno(data: string) {
  const newDate = format(new Date(data), "dd MMMM", { locale: ptBR });

  return newDate;
}
